"use client";

import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";

import { type BillingPeriod } from "./pricingTypes";

type BillingPeriodContextValue = {
  billingPeriod: BillingPeriod;
  setBillingPeriod: (period: BillingPeriod) => void;
};

const BillingPeriodContext = createContext<BillingPeriodContextValue | null>(
  null,
);

export function MarketingPricingProvider({
  children,
}: Readonly<{ children: ReactNode }>) {
  const [billingPeriod, setBillingPeriod] = useState<BillingPeriod>("yearly");

  const value = useMemo(
    () => ({ billingPeriod, setBillingPeriod }),
    [billingPeriod],
  );

  return (
    <BillingPeriodContext.Provider value={value}>
      {children}
    </BillingPeriodContext.Provider>
  );
}

export function useBillingPeriod(): BillingPeriodContextValue {
  const context = useContext(BillingPeriodContext);

  if (!context) {
    throw new Error(
      "useBillingPeriod must be used within a MarketingPricingProvider",
    );
  }

  return context;
}
